module.exports = __webpack_public_path__ + "img/ds_hj.93f88ce0.png";